import { Search, Wifi, WifiOff, BellRing } from "lucide-react";

const Avatar = ({ user, size = 11 }) => (
  user?.picture
    ? <img src={user.picture} className={`w-${size} h-${size} rounded-full object-cover`} alt="" />
    : <div className={`w-${size} h-${size} rounded-full bg-accent flex items-center justify-center font-bold text-[#3D405B]`}>{user?.name?.[0] || "?"}</div>
);

export default function ThreadList({ threads, activeId, onSelect, connected, onToggleSearch, searchOpen, contacts, onPickContact, userRole, onTestNotification }) {
  return (
    <aside className="border-r border-[#3D405B]/5 bg-[#FDFBF7]">
      <div className="p-5 border-b border-[#3D405B]/5 flex items-center justify-between">
        <h2 className="font-extrabold text-[#3D405B] flex items-center gap-2">
          Conversations
          <span title={connected ? "Live" : "Reconnecting…"} data-testid={connected ? "ws-connected" : "ws-disconnected"}>
            {connected ? <Wifi size={13} className="text-secondary" /> : <WifiOff size={13} className="text-[#7A7D96]" />}
          </span>
        </h2>
        <div className="flex items-center gap-1">
          {onTestNotification && (
            <button onClick={onTestNotification} title="Send a test notification to yourself" className="p-2 rounded-full hover:bg-[#3D405B]/5 text-[#3D405B]" data-testid="test-notification-btn">
              <BellRing size={16} />
            </button>
          )}
          <button onClick={onToggleSearch} className="p-2 rounded-full hover:bg-[#3D405B]/5" data-testid="chat-new-btn"><Search size={16} /></button>
        </div>
      </div>

      {searchOpen && (
        <div className="p-3 border-b border-[#3D405B]/5 bg-muted/30">
          <div className="text-xs font-bold uppercase tracking-wider text-[#7A7D96] mb-2 px-1">{userRole === "counsellor" ? "Your clients" : "Counsellors"}</div>
          <div className="max-h-56 overflow-auto">
            {contacts.length === 0 ? (
              <div className="text-sm text-[#7A7D96] p-2">No contacts yet.</div>
            ) : contacts.map((c) => (
              <button key={c.user_id} onClick={() => onPickContact(c)} className="w-full flex items-center gap-3 p-2 rounded-xl hover:bg-[#3D405B]/5 text-left" data-testid={`contact-${c.user_id}`}>
                <Avatar user={c} size={9} />
                <div className="text-sm">
                  <div className="font-bold text-[#3D405B]">{c.name}</div>
                  <div className="text-xs text-[#7A7D96] capitalize">{c.role}</div>
                </div>
              </button>
            ))}
          </div>
        </div>
      )}

      <div className="overflow-y-auto" style={{ maxHeight: "60vh" }}>
        {threads.length === 0 ? (
          <div className="p-6 text-sm text-[#7A7D96]">No conversations yet. Use the search icon to start a new chat.</div>
        ) : threads.map((t) => {
          const o = t.other || { name: "Unknown", user_id: t.other_id };
          return (
            <button key={t.other_id} onClick={() => onSelect(o)} className={`w-full flex items-center gap-3 p-3.5 border-b border-[#3D405B]/5 text-left transition-colors ${activeId === t.other_id ? "bg-primary/8" : "hover:bg-[#3D405B]/5"}`} data-testid={`thread-${t.other_id}`}>
              <Avatar user={o} />
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between gap-2">
                  <div className="font-bold text-[#3D405B] truncate">{o.name}</div>
                  {t.unread > 0 && <span className="pill bg-primary text-white text-[10px] px-2">{t.unread}</span>}
                </div>
                <div className="text-xs text-[#7A7D96] truncate">{t.last_message?.body}</div>
              </div>
            </button>
          );
        })}
      </div>
    </aside>
  );
}
